<template>
  <div class="container-custom" :style="styleObject">
    <header>
      <Header></Header>
    </header>
    <div class="ksk-mr__scroll" v-if="isLoadDone">
      <template v-if="isLogined">
        <!-- KSK017: back + title -->
        <div class="ksk-mr__head">
          <KskButton
            variant="muted"
            size="md"
            icon="arrow_back"
            class="ksk-mr__back"
            @click="gotoPath('CheckoutPageKiosk')"
          >
            {{ $t("kiosk.rewards.backToCart") }}
          </KskButton>
          <h1 class="ksk-mr__title">{{ $t("kiosk.rewards.title") }}</h1>
        </div>

        <!-- KSK017: search -->
        <div class="ksk-mr__search">
          <span class="material-icons-round ksk-mr__search-icon">search</span>
          <search-input
            :onChangesearchKeyword="onChangesearchKeyword"
            :placeholder="$t('kiosk.rewards.search')"
          />
        </div>

        <!-- KSK017: reward cards -->
        <div class="ksk-mr__list" v-if="promocodeData.length">
          <div
            v-for="(item, index) in promocodeData"
            :key="index"
            class="ksk-mr__card"
            :class="{
              'ksk-mr__card--applied':
                selectedReward && selectedReward.voucher_id == item.voucher_id,
              'ksk-mr__card--off': !(item.isCanUseThisBranch && !item.isVoucherLocked),
            }"
          >
            <img
              v-if="hasRewardImage(item)"
              :src="`${item.icon_url}`"
              alt=""
              class="ksk-mr__img"
              @error="markImageBroken(item)"
            />
            <span v-else class="ksk-mr__img ksk-mr__img--placeholder material-icons-round">confirmation_number</span>
            <div class="ksk-mr__body">
              <div class="ksk-mr__name">{{ item.reward_title ?? "" }}</div>
              <div v-if="item.bundle_name" class="ksk-mr__bundle">
                {{ $t("kiosk.rewards.bundle", { name: item.bundle_name }) }}
              </div>
              <div v-if="item.order_total" class="ksk-mr__meta">
                {{ $t("kiosk.rewards.minSpend", { amount: "$" + item.order_total }) }}
              </div>
              <div v-if="item.expiry_date_text" class="ksk-mr__meta">
                {{ item.expiry_date_text }}
              </div>
              <div class="ksk-mr__links">
                <button
                  v-if="item.terms_conditions"
                  type="button"
                  class="ksk-mr__tc"
                  @click="openTermAndConditions(item.terms_conditions, item.reward_title)"
                >
                  {{ $t("kiosk.rewards.terms") }}
                </button>
                <span
                  v-if="!(item.isCanUseThisBranch && !item.isVoucherLocked)"
                  class="ksk-mr__reason"
                >
                  <span class="material-icons-round">lock</span>
                  {{ $t(item.isCanUseThisBranch ? "kiosk.rewards.locked" : "kiosk.rewards.notAtOutlet") }}
                </span>
              </div>
            </div>
            <div class="ksk-mr__action">
              <span
                v-if="selectedReward && selectedReward.voucher_id == item.voucher_id"
                class="material-icons-round ksk-mr__check"
                >check_circle</span
              >
              <div v-if="item.isCanUseThisBranch && !item.isVoucherLocked">
                <KskButton
                  v-if="
                    selectedReward &&
                    selectedReward.voucher_id == item.voucher_id
                  "
                  variant="muted"
                  size="md"
                  icon="close"
                  class="ksk-mr__btn"
                  @click="handleRadioClick(null)"
                >
                  {{ $t("kiosk.common.remove") }}
                </KskButton>
                <KskButton
                  v-else
                  variant="outlined"
                  size="md"
                  class="ksk-mr__btn"
                  @click="handleRadioClick(item)"
                >
                  {{ $t("kiosk.rewards.apply") }}
                </KskButton>
              </div>
              <div v-else>
                <KskButton
                  v-if="
                    selectedReward &&
                    selectedReward.voucher_id == item.voucher_id
                  "
                  variant="muted"
                  size="md"
                  icon="close"
                  class="ksk-mr__btn"
                  @click="handleRadioClick(null)"
                >
                  {{ $t("kiosk.common.remove") }}
                </KskButton>
                <KskButton v-else variant="outlined" size="md" class="ksk-mr__btn" disabled>
                  {{ $t("kiosk.rewards.apply") }}
                </KskButton>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="ksk-mr__empty">
          <span class="material-icons-round">redeem</span>
          {{ $t("kiosk.rewards.empty") }}
        </div>
      </template>
      <div v-else class="ksk-mr__empty">
        <span class="material-icons-round">redeem</span>
        {{ $t("kiosk.rewards.empty") }}
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-term-and-conditions-modal"
        data-bs-toggle="modal"
        data-bs-target="#modalShowTermAndConditions"
      ></button>
      <div
        class="modal fade"
        id="modalShowTermAndConditions"
        tabindex="-1"
        aria-labelledby="modalShowTermAndConditionsLabel"
        aria-hidden="true"
      >
        <!-- KSK036: P19 kiosk Terms & Conditions (theme 2) -->
        <KskModalShell :width="860" :show-close="false">
          <div class="ksk-tc__top">
            <div class="ksk-tc__badge">
              <span class="material-icons-round">description</span>
            </div>
            <button
              type="button"
              class="ksk-tc__close"
              :aria-label="$t('kiosk.common.close')"
              data-bs-dismiss="modal"
            >
              <span class="material-icons-round">close</span>
            </button>
          </div>
          <h2 class="ksk-tc__title">{{ $t("kiosk.rewards.termsTitle") }}</h2>
          <p v-if="tcRewardTitle" class="ksk-tc__sub">{{ tcRewardTitle }}</p>
          <div class="ksk-tc__box">
            <div
              ref="tcScroll"
              class="ksk-tc__scroll"
              v-html="contentTermAndCondition"
              @scroll="updateTcFade"
            ></div>
            <div class="ksk-tc__fade" :class="{ 'ksk-tc__fade--on': tcHasMore }">
              <span class="ksk-tc__hint">
                {{ $t("kiosk.rewards.scrollAll") }}
                <span class="material-icons-round">arrow_downward</span>
              </span>
            </div>
          </div>
          <template #footer>
            <!-- `btn-close-modal` kept from the old markup. -->
            <KskButton block class="btn-close-modal" data-bs-dismiss="modal">
              {{ $t("kiosk.common.close") }}
            </KskButton>
          </template>
        </KskModalShell>
      </div>
    </div>
  </div>
  <ModalSelectFreeItem
    :keyReload="keyReload"
    :rewardId="rewardIdSelect"
    :handleUseVoucher="handleUseVoucher"
    :removeVoucherSelected="removeVoucherSelected"
    :isKiosk="true"
    :rewardTitle="selectedReward ? selectedReward.reward_title || '' : ''"
  />
  <material-loading :active="loaderActive" />
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import PromocodeService from "../../services/promocode.service";
import moment from "moment";
import $ from "jquery";
import SearchInput from "@/components/SearchInput.vue";
import ModalSelectFreeItem from "@/components/ModalSelectFreeItem.vue";
import { gotoMemberLogin, localStorageName } from "@/config/utils";
import { FREE_ITEM } from "@/config/const";
import Header from "../kiosk/components/Header.vue";
import KskButton from "./components/ui/KskButton.vue";
import KskModalShell from "./components/ui/KskModalShell.vue";

export default {
  name: "MyRewardPageKiosk",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    SearchInput,
    ModalSelectFreeItem,
    Header,
    KskButton,
    KskModalShell,
  },
  data() {
    return {
      // icon_url values whose image failed to load (display only).
      brokenRewardImages: {},
      isLoadDone: false,
      snackbar: null,
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      cutleryValue: 1,
      memberInfo: JSON.parse(
        localStorage.getItem(localStorageName("memberInfo"), "")
      ),
      loaderActive: false,
      searchKeyword: "",
      contentTermAndCondition: "",
      tcRewardTitle: "",
      tcHasMore: false,
      selectedReward: [],
      promocodeData: [],
      message: "",
      searchTimerId: null,
      fromCart: this.$route.params.from_cart ?? false,
      fromOrderHistory: this.$route.params.from_order_history ?? false,
      isLogined: false,
      rewardIdSelect: 0,
      keyReload: "keyReload",
      freeItem: FREE_ITEM,
      merchantCode: "",
      branchCode: "",
    };
  },
  async created() {
    this.merchantCode = this.$route.params.merchant_code;
    this.branchCode = this.$route.params.branch_code;
    var memberInfoData = JSON.parse(
      localStorage.getItem(localStorageName("member"), "")
    );

    if (memberInfoData) {
      this.isLogined = true;
      this.isLoadDone = false;
      await this.getList();
      this.isLoadDone = true;
    } else {
      this.isLogined = false;
      this.isLoadDone = true;

      this.gotoPath("LandingPageKiosk");
    }
  },
  mounted() {
    $(".modal-backdrop.fade.show").remove();
    // KSK062: no bottom bar here — keep the Powered-by strip on the canvas.
    document.documentElement.classList.add("ksk-powered-on-canvas");
    // KSK036: the T&C body is display:none until Bootstrap shows the modal,
    // so the overflow can only be measured once it is visible.
    this.tcModalEl = document.getElementById("modalShowTermAndConditions");
    if (this.tcModalEl) this.tcModalEl.addEventListener("shown.bs.modal", this.onTcShown);
  },
  beforeUnmount() {
    document.documentElement.classList.remove("ksk-powered-on-canvas");
    if (this.tcModalEl) this.tcModalEl.removeEventListener("shown.bs.modal", this.onTcShown);
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
  },
  methods: {
    // Real voucher artwork, not the default "no image" file (or one that
    // failed to load): otherwise a voucher tile is shown instead.
    hasRewardImage(item) {
      const url = item && item.icon_url;
      if (!url || this.brokenRewardImages[url]) return false;
      return !/no[-_]?image|placeholder|default/i.test(url);
    },
    markImageBroken(item) {
      if (item && item.icon_url) this.brokenRewardImages[item.icon_url] = true;
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    gotoSignIn() {
      gotoMemberLogin("myreward");
    },
    gotoSignUp() {
      gotoMemberLogin("myreward");
    },
    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList();
      }, 1000);
    },
    async getList() {
      this.showLoader();

      let dataForm = {
        search_keyword: this.searchKeyword,
        type: "",
        merchant_id: localStorage.getItem(localStorageName("MERCHANT_ID"), 0),
        branch_code: this.branch.branch_code,
      };

      await PromocodeService.getMyRewardOrderingOnline(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.promocodeData = response.data.data;

            const storedReward = localStorage.getItem(
              localStorageName("SELECTED_REWARD")
            );
            if (storedReward) {
              var storedRewardConveted = JSON.parse(storedReward);
              if (storedRewardConveted && storedRewardConveted.length > 0) {
                this.selectedReward = storedRewardConveted[0];
              }
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },
    getFormattedExpirationDate(expirationDate) {
      const now = moment();
      const expiration = moment(expirationDate);
      const daysRemaining = expiration.diff(now, "days");

      if (daysRemaining === 0) {
        return "expired today";
      } else if (daysRemaining === 1) {
        return "expires in 1 day";
      } else {
        return `expires in ${daysRemaining} days`;
      }
    },
    openTermAndConditions(content, rewardTitle = "") {
      this.contentTermAndCondition = content;
      this.tcRewardTitle = rewardTitle || "";
      this.tcHasMore = false;
      $(".btn-term-and-conditions-modal").click();
    },
    // scrollTop can't be reset while the modal is display:none, so start each
    // opening from the top once Bootstrap has shown it.
    onTcShown() {
      if (this.$refs.tcScroll) this.$refs.tcScroll.scrollTop = 0;
      this.updateTcFade();
    },
    updateTcFade() {
      const el = this.$refs.tcScroll;
      if (!el) return;
      this.tcHasMore = el.scrollTop + el.clientHeight < el.scrollHeight - 4;
    },
    percentageUsed(total, used) {
      return (used / total) * 100;
    },
    handleUseVoucher(itemSelected = null) {
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      if (this.selectedReward) {
        this.selectedReward.item_selected = itemSelected;

        localStorage.setItem(
          localStorageName("SELECTED_REWARD"),
          JSON.stringify([this.selectedReward])
        );
        // KSK065: Checkout throws confetti once the reward is applied.
        localStorage.setItem(localStorageName("KIOSK_REWARD_JUST_APPLIED"), "1");
        this.gotoPath("CheckoutPageKiosk");
      } else {
        this.gotoPath("CheckoutPageKiosk");
      }
    },
    handleRadioClick(item) {
      this.rewardIdSelect = 0;
      if (item && item.reward_type == FREE_ITEM) {
        this.selectedReward = item;
        this.rewardIdSelect = item.id;
        this.keyReload = Math.random().toString();
        $(".btn-select-free-item-modal").click();
      } else {
        if (this.fromOrderHistory) {
          localStorage.removeItem(
            localStorageName("SELECTED_REWARD_FROM_ORDER_HISTORY")
          );
          localStorage.setItem(
            localStorageName("SELECTED_REWARD_FROM_ORDER_HISTORY"),
            JSON.stringify([item])
          );
          this.gotoPath("CheckoutPageKiosk");
        } else {
          this.selectedReward = item;
          this.handleUseVoucher();
        }
      }
    },
    removeVoucherSelected() {
      this.selectedReward = null;
      this.rewardIdSelect = 0;
    },
    gotoPath(name) {
      this.$router.push({
        name: name,
        params: {
          merchant_code: this.merchantCode,
          branch_code: this.branchCode,
        },
      });
    },
  },
};
</script>
<style scoped>
.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* KSK017 — scroll area under the header (cards in a centred 760px column,
   same as the payment screens) */
.ksk-mr__scroll {
  position: fixed;
  top: var(--ksk-header-height);
  left: 0;
  right: 0;
  bottom: var(--ksk-powered-height);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-3) var(--ksk-space-3) var(--ksk-space-6);
  background: var(--ksk-background);
  font-family: var(--ksk-font);
  color: var(--ksk-text);
}
.ksk-mr__scroll::-webkit-scrollbar {
  display: none;
}

.ksk-mr__scroll > * {
  width: 100%;
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
}
/* The header keeps the full page width (as before), so Back to Cart has
   room left of the centred title. */
.ksk-mr__scroll > .ksk-mr__head {
  max-width: none;
}

/* Back + title */
.ksk-mr__head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
}
.ksk-mr__back {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 64px;
}
.ksk-mr__back:active:not(:disabled) {
  transform: translateY(-50%) scale(0.97);
}
.ksk-mr__title {
  margin: 0;
  font-family: inherit;
  font-size: var(--ksk-headline-size);
  line-height: var(--ksk-headline-lh);
  font-weight: 800;
  color: var(--ksk-primary);
}

/* Search */
.ksk-mr__search {
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 var(--ksk-space-3);
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
}
.ksk-mr__search-icon {
  font-size: 32px;
  color: var(--ksk-text-secondary);
}
.ksk-mr__search :deep(> div) {
  flex: 1;
  margin: 0 !important;
}
.ksk-mr__search :deep(input.nosubmit) {
  width: 100%;
  height: 62px;
  padding: 0 var(--ksk-space-2);
  border: 0 !important;
  background: none;
  font-family: var(--ksk-font);
  font-size: var(--ksk-body-size);
  color: var(--ksk-text);
}
.ksk-mr__search :deep(input[type="search"]::placeholder) {
  font-size: var(--ksk-body-size);
  color: var(--ksk-text-secondary);
}

/* Reward cards */
.ksk-mr__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ksk-mr__card {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-2) 20px var(--ksk-space-2) var(--ksk-space-2);
  border: 2px solid transparent;
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
}
.ksk-mr__card--applied {
  border-color: var(--ksk-primary);
  background: var(--ksk-primary-container);
}
/* Not usable here: listed after the usable ones (display order only). */
.ksk-mr__card--off {
  order: 1;
  background: var(--ksk-surface-muted);
  box-shadow: none;
}
.ksk-mr__img {
  flex: none;
  width: 80px;
  height: 80px;
  border-radius: 14px;
  object-fit: cover;
  background: var(--ksk-surface-muted);
}
/* No artwork: a voucher tile instead of a broken-image icon. */
.ksk-mr__img--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
  font-size: 40px;
}
.ksk-mr__card--applied .ksk-mr__img--placeholder {
  background: var(--ksk-surface);
}
.ksk-mr__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ksk-mr__name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 22px;
  line-height: 30px;
  font-weight: 700;
  word-break: break-word;
}
.ksk-mr__bundle {
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-style: italic;
  font-weight: 600;
  color: var(--ksk-text);
}
.ksk-mr__meta {
  font-size: 17px;
  line-height: 22px;
  color: var(--ksk-text-secondary);
}
.ksk-mr__links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ksk-space-2);
  margin-top: 4px;
}
.ksk-mr__tc {
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  color: var(--ksk-primary);
  text-decoration: underline;
  text-underline-offset: 4px;
}
.ksk-mr__reason {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 600;
  color: var(--ksk-text-secondary);
}
.ksk-mr__reason .material-icons-round {
  font-size: 20px;
}
.ksk-mr__card--off .ksk-mr__img,
.ksk-mr__card--off .ksk-mr__name,
.ksk-mr__card--off .ksk-mr__meta {
  opacity: 0.5;
}
.ksk-mr__action {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
}
.ksk-mr__check {
  font-size: 32px;
  color: var(--ksk-primary);
}
.ksk-mr__btn {
  min-width: 140px;
  height: 56px;
  font-size: 20px;
}

/* Empty */
.ksk-mr__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-6) var(--ksk-space-4);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text-secondary);
}
.ksk-mr__empty .material-icons-round {
  font-size: 72px;
  color: var(--ksk-primary);
}

/* KSK036 — P19 Terms & Conditions popup */
.ksk-tc__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ksk-tc__badge {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
}
.ksk-tc__badge .material-icons-round {
  font-size: 40px;
}
.ksk-tc__close {
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.ksk-tc__close .material-icons-round {
  font-size: 32px;
}
.ksk-tc__close:active {
  transform: scale(0.95);
}
.ksk-tc__title {
  margin: var(--ksk-space-2) 0 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-headline-size);
  line-height: var(--ksk-headline-lh);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ksk-text);
}
.ksk-tc__sub {
  margin: var(--ksk-space-1) 0 0;
  font-size: var(--ksk-label-size);
  line-height: var(--ksk-label-lh);
  font-weight: 600;
  color: var(--ksk-text-secondary);
}
.ksk-tc__box {
  position: relative;
  margin-top: var(--ksk-space-3);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface-muted);
  overflow: hidden;
}
.ksk-tc__scroll {
  max-height: 680px;
  overflow-y: auto;
  padding: var(--ksk-space-4);
  white-space: pre-line;
  word-break: break-word;
  font-size: var(--ksk-body-size);
  line-height: var(--ksk-body-lh);
  color: var(--ksk-text);
}
.ksk-tc__fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 112px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 12px;
  background: linear-gradient(to top, var(--ksk-surface-muted) 30%, transparent);
  pointer-events: none;
  opacity: 0;
  transition: opacity 200ms ease-out;
}
.ksk-tc__fade--on {
  opacity: 1;
}
.ksk-tc__hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 500;
  color: var(--ksk-text-secondary);
}
.ksk-tc__hint .material-icons-round {
  font-size: 20px;
}
</style>
